export const replaceImagePath = (content?: string) => {
  const regex = /\/caas\/content\/api\/v1\/admin\/files/g;

  return content?.replace(regex, '/uploads');
};
